import { trigger, style, transition, animate, group, query, animateChild } from '@angular/animations';

export const fadeAnimation = trigger('fade', [
  transition('void => *', [
    group([
      query('*', animateChild(), { optional: true }),
      style({ opacity: '0' }),
      animate(200, style({ opacity: '1' }))
    ])
  ]),
  transition('* => void', [
    group([query('*', animateChild(), { optional: true }), animate(200, style({ opacity: '0' }))])
  ])
]);
